module.exports = __webpack_public_path__ + "static/img/recommend_success.f85b4d95.png";